'use client';
import SelectFilterOptions from './SelectFilterOptions';
import useSelectFilter from './useSelectFilter';
import Dropdown from '@/external/components/Dropdown';

type Props = {
  type: 'categories' | 'providers';
  menuItem?: string;
  theme?: string;
  placeholder: string;
  selectText: string;
  searchParams: Record<string, string> | undefined;
  className: string;
  dataTestId?: string;
};

const SelectFilter: FC<Props> = ({
  type,
  menuItem,
  theme,
  placeholder,
  selectText,
  searchParams = {},
  className,
  dataTestId,
}) => {
  const { selected, handleChange } = useSelectFilter({ type, searchParams });
  const placeholderText =
    selected.length === 0 ? placeholder : selected.length.toString();

  return (
    <Dropdown
      data-testid={dataTestId}
      size="lg"
      value={selected}
      onChange={handleChange}
      multiple
      className={className}
    >
      {({ open }) => (
        <>
          <Dropdown.MultiSelect
            open={open}
            label={<div className="text-moon-14 text-trunks">{selectText}</div>}
            placeholder={placeholderText}
            className="text-moon-14"
          />
          <Dropdown.Options className="max-h-96 z-30" menuWidth="w-60">
            <SelectFilterOptions
              type={type}
              menuItem={menuItem}
              theme={theme}
            />
          </Dropdown.Options>
        </>
      )}
    </Dropdown>
  );
};

export default SelectFilter;
